import { isApiError } from '@subscriptions/application/errors';

/** Backend code of a failed request, for events and logs. Undefined when the failure did not come
 * from the API — a network error has no code to report. */
export const resolveApiErrorCode = (error: unknown): string | undefined => (isApiError(error) ? error.code : undefined);
